import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { apiUrl } from '#GameFrontend/services/api';

export type DevGateState = {
	loading: boolean;
	enabled: boolean;
	authenticated: boolean;
	email: string | null;
	loginUrl: string | null;
	logoutUrl: string | null;
};

const defaultState: DevGateState = {
	loading: true,
	enabled: false,
	authenticated: true,
	email: null,
	loginUrl: null,
	logoutUrl: null,
};

const DevGateContext = createContext<DevGateState>(defaultState);

export function DevGateProvider({ children }: { children: ReactNode }) {
	const [state, setState] = useState<DevGateState>(defaultState);

	useEffect(() => {
		const load = async () => {
			try {
				const configRes = await fetch(apiUrl('/auth/sso/config'), { credentials: 'include' });
				const config = await configRes.json();

				if (!config.enabled) {
					setState({
						loading: false,
						enabled: false,
						authenticated: true,
						email: null,
						loginUrl: null,
						logoutUrl: null,
					});
					return;
				}

				const sessionRes = await fetch(apiUrl('/auth/sso/session'), { credentials: 'include' });
				const session = await sessionRes.json();

				setState({
					loading: false,
					enabled: true,
					authenticated: Boolean(session.authenticated),
					email: session.email ?? null,
					loginUrl: config.loginUrl ?? null,
					logoutUrl: config.logoutUrl ?? null,
				});
			} catch {
				setState({
					loading: false,
					enabled: false,
					authenticated: true,
					email: null,
					loginUrl: null,
					logoutUrl: null,
				});
			}
		};

		load();
	}, []);

	return <DevGateContext.Provider value={state}>{children}</DevGateContext.Provider>;
}

export function useDevGate() {
	return useContext(DevGateContext);
}
